import type { ReactNode } from "react";
import { DropdownButtonSlim as SharedDropdownButtonSlim } from "@sellar-io/components";

export {
  Dropdown,
  DropdownButton,
  DropdownItems,
  DropdownItem,
  DropdownHeadingItem,
} from "@sellar-io/components";

export const DropdownButtonSlim = ({ children }: { children?: ReactNode }) => (
  <SharedDropdownButtonSlim className="shadow-[0_2px_2px_0_rgba(0,0,0,0.15)]">
    {children}
  </SharedDropdownButtonSlim>
);
